import { render, staticRenderFns } from "./MessageEmployeeField.vue?vue&type=template&id=328aab96&scoped=true&"
import script from "./MessageEmployeeField.vue?vue&type=script&lang=js&"
export * from "./MessageEmployeeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328aab96",
  null
  
)

export default component.exports